export default function deviceListSort(state = "name", action) {
  switch (action.type) {
    case "SET_DEVICE_LIST_SORT_PROPERTY":
      return action.selection ? action.selection.value : state
    default:
      return state
  }
}
